import React from "react";
import DataTable from "../../../../components/DataTable";
import { useRoiIncomeDataUserQuery } from "../../../../Services/earningApi";
// import DataTable from "../../../../components/DataTable";
// import { useRoiIncomeDataUserQuery } from "../../../../Services/earningApi";

const RoiInocmeTable = () => {
  const { data } = useRoiIncomeDataUserQuery();
  const columns = [
    { id: "sn", label: "S.N", minWidth: 20 },
    { id: "packages", label: "Package", minWidth: 100 },
    {
      id: "date",
      label: "Date",
      minWidth: 120,
    },
    {
      id: "roi_per_day",
      label: "ROI Per Day",
      minWidth: 110,
    },
    {
      id: "amount",
      label: "Amount",
      minWidth: 80,
    },
    {
      id: "total_amount",
      label: "Total Amount",
      minWidth: 110,
    },
  ];

  function createData(
    sn,
    packages,
    date,
    roi_per_day,
    amount,
    total_amount,
  ) {
    return {
      sn,
      packages,
      date,
      roi_per_day,
      amount,
      total_amount,
    };
  }
  // console.log(data);
  const rows = data?.map((d,i) =>
    createData(
      i +1,
      "$" + d.packages,
      new Date(d.day).toDateString(),
      d.roi_per_day + "%",
      d.amount,
      d.total_amount,
    )
  );
  // console.log(data);
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default RoiInocmeTable;
